/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface PatientsPatientExportPermissions { 
    add: boolean;
    change: boolean;
    destroy: boolean;
    view: boolean;
}
export const PatientsPatientExportPermissions_add_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientsPatientExportPermissions_change_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientsPatientExportPermissions_destroy_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientsPatientExportPermissions_view_Validators: ValidatorFn[] =
    [  Validators.required, ];


